import { render, staticRenderFns } from "./EventAccessTable.vue?vue&type=template&id=6c49ca0a&"
import script from "./EventAccessTable.vue?vue&type=script&lang=js&"
export * from "./EventAccessTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports